import FormControlLabel from "@mui/material/FormControlLabel";
import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import Stack from "@rui/Stack";

export const SettingSectionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.shades.neutral[800],
  fontSize: "1.125rem",
  fontWeight: 600,
}));

export const TabContent = styled(Stack)({
  paddingBottom: "70px",
});

export const SwitchControlLabel = styled(FormControlLabel)({
  display: "flex",
  marginLeft: 0,
  width: "fit-content",
  "& .MuiSwitch-root": {
    marginBottom: 0,
    marginLeft: 0,
    marginTop: 0,
  },
});
